import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from '../../../../global/environment';

export async function getUserPermissionsByEmailAPI(email) {
  const url = `${AWS_API_URL}/user/permissions?email=${encodeURIComponent(email)}`;

  return getRequest(url, await authorize());
}

export function hasPermissionsByEmail(permissionsData, permissionKey, action = 'read') {

  if (!permissionsData || !permissionsData.permissions) return false;
  const perm = permissionsData.permissions[permissionKey];
  return !!(perm && perm[action]);
}
